import { Ref } from "react";

import { StoreDirectionsMapComponent } from "./storeDirectionsMap.component";

type StoreDirectionsMapProps = {
    ref?: Ref<HTMLDivElement>;
};

const StoreDirectionsMap = ({ ref }: StoreDirectionsMapProps) => {
    return <StoreDirectionsMapComponent ref={ref} />;
};

export { StoreDirectionsMap };
